import React, { forwardRef, useImperativeHandle } from "react";

import Labels from "../../../assets/labels";
import { Controller, useFormContext } from "react-hook-form";
import { Selector, useLang } from "@manulife/mux";
import NumberConstants from "../../../assets/appStyledComponents/numberConstant.json";

const RtgSynChildProtectionRiders = forwardRef(({ fieldName }, ref) => {
  const { num1280 } = NumberConstants;
  const selectedLang = useLang();
  const { control } = useFormContext(); // retrieve all hook methods

  const focusChildProtectionRiders = () => {
    // focus on first button 
    document.getElementById(`${fieldName}-0`)?.focus();
  };

  useImperativeHandle(ref, () => ({
    focus: focusChildProtectionRiders
  }));

  return (
    <>
      <Controller
        control={control}
        name={fieldName}
        rules={{
          required: Labels.errors.required[`${selectedLang}`],
        }}
        render={({
          field: { onChange, onBlur, value, name },
          fieldState: { error },
        }) => (
          <Selector
            id={name}
            label={Labels.childProtectionRiders[`${selectedLang}`].label}
            ariaLabel={Labels.childProtectionRiders[`${selectedLang}`].label}
            ariaRequired={true}
            values={Labels.childProtectionRiders[`${selectedLang}`].options}
            customStyle={{
              rootStyle: {
                width: "75%",
                media: [
                  {
                    maximum: num1280,
                    width: "100%",
                  },
                ],
              },
            }}
            selected={value}
            onBlur={onBlur}
            onChange={onChange}
            errors={error ? [error.message] : undefined}
            callouts={false}
          />
        )}
      />
    </>
  );
});

export default RtgSynChildProtectionRiders;
